import { memo } from 'react';
import { Link } from 'react-router-dom';
import { IHeaderMenuLinkProps } from './header.types';

const HeaderMenuLink: React.FC<IHeaderMenuLinkProps> = ({ item }) => (
  <div className='relative lg:hover:scale-105 transition-all
     text-14 font-normal font-inter text-black whitespace-nowrap'>
      {
        (item.isExternal || item.isHash) && (
          <a
            className='font-bold lg:font-normal cursor-pointer uppercase'
            href={item.path}
            rel='noreferrer'
            {...!item.isHash ? { target: '_blank' } : {}}
          >
            {item.text}
          </a>
        )
      }
      {
        item.isButton && (
          <a
            className='text-white bg-black text-16 leading-18
              rounded-[50px] font-sans font-bold px-8 py-4 inline-block lg:inline'
            href={item.path}
          >
            {item.text}
          </a>
        )
      }
      {
        !item.isExternal && !item.isHash && !item.isButton && (
          <Link
            to={item.path}
            className='font-bold cursor-pointer uppercase lg:font-normal'
          >
            {item.text}
          </Link>
        )
      }
  </div>
);

export default memo(HeaderMenuLink);
